import {
  AddressType,
  Country,
  Currency,
  IncorporationRequestStatus,
  LegacyDocumentType,
} from '@commenda/prisma';
// import {
//   AccountingBasis,
//   AccountingFrequency,
//   CorporationOnboardingStages,
//   IAddress,
//   Marketplace,
//   MCQTypes,
// } from '@commenda/types';
import { IAddress } from './address.types';
import {
  AccountingBasis,
  AccountingFrequency,
  CorporationOnboardingStages,
  Marketplace,
  MCQTypes,
} from './business-entity';

export { MCQTypes };

export enum USStatesAndTerritories {
  AL = 'AL', // Alabama
  AK = 'AK', // Alaska
  AZ = 'AZ', // Arizona
  AR = 'AR', // Arkansas
  CA = 'CA', // California
  CO = 'CO', // Colorado
  CT = 'CT', // Connecticut
  DE = 'DE', // Delaware
  FL = 'FL', // Florida
  GA = 'GA', // Georgia
  HI = 'HI', // Hawaii
  ID = 'ID', // Idaho
  IL = 'IL', // Illinois
  IN = 'IN', // Indiana
  IA = 'IA', // Iowa
  KS = 'KS', // Kansas
  KY = 'KY', // Kentucky
  LA = 'LA', // Louisiana
  ME = 'ME', // Maine
  MD = 'MD', // Maryland
  MA = 'MA', // Massachusetts
  MI = 'MI', // Michigan
  MN = 'MN', // Minnesota
  MS = 'MS', // Mississippi
  MO = 'MO', // Missouri
  MT = 'MT', // Montana
  NE = 'NE', // Nebraska
  NV = 'NV', // Nevada
  NH = 'NH', // New Hampshire
  NJ = 'NJ', // New Jersey
  NM = 'NM', // New Mexico
  NY = 'NY', // New York
  NC = 'NC', // North Carolina
  ND = 'ND', // North Dakota
  OH = 'OH', // Ohio
  OK = 'OK', // Oklahoma
  OR = 'OR', // Oregon
  PA = 'PA', // Pennsylvania
  RI = 'RI', // Rhode Island
  SC = 'SC', // South Carolina
  SD = 'SD', // South Dakota
  TN = 'TN', // Tennessee
  TX = 'TX', // Texas
  UT = 'UT', // Utah
  VT = 'VT', // Vermont
  VA = 'VA', // Virginia
  WA = 'WA', // Washington
  WV = 'WV', // West Virginia
  WI = 'WI', // Wisconsin
  WY = 'WY', // Wyoming
  // Federal district
  DC = 'DC', // District of Columbia
  // Territories
  PR = 'PR', // Puerto Rico
}

export type TSetNotification = React.Dispatch<
  React.SetStateAction<TNotification>
>;

export type TRefreshState = () => unknown; // some shit old type used in callback states for documents

export type TNotification = {
  show: boolean;
  valid: boolean;
  title: string;
  message: string;
  autoClose?: boolean;
  timeout?: number;
};

export enum AccountingSlab {
  LESS_THAN_THIRTY_TRANSACTIONS = 'LESS_THAN_THIRTY_TRANSACTIONS',
  THIRTY_TO_SEVENTY_TRANSACTIONS = 'THIRTY_TO_SEVENTY_TRANSACTIONS',
  GREATER_THAN_SEVENTY_TRANSACTIONS = 'GREATER_THAN_SEVENTY_TRANSACTIONS',
}

enum Gender {
  Male = 'Male',
  Female = 'Female',
  Other = 'Other',
}

export interface USBOI {
  addressTypeGivenByDirector?: {
    directorId: number;
    type: AddressType;
    isCompanyApplicant?: boolean;
  }[];
  // Stakeholders whose information was confirmed by the user:
  confirmedDirectors: number[];
}

export type DirectorPersonalDetails = {
  hasDSC?: boolean;
  gender?: Gender;
  parentName?: string;
  panCardNumber?: string;
  aadharCardNumber?: string;
  nationality?: string;
  residence?: string;
  taxPayerIdentificationNumber?: string;
  educationalQualification?: EducationalQualificationEnum;
  countriesWithDirectorPersonalTaxes?: Country[];
  occupation?: string;
  placeOfBirth?: {
    country: Country;
    state: string;
    district: string;
  };
  dateOfOccupancyInCurrentAddress?: string;
  isPoliticallyExposed?: boolean;
  haveUAEResidenceVisa?: boolean;
  passportCountryOfIssue?: Country;
  passportExpirationDate?: string;
  passportNumber?: string;
};

export type NotificationType = {
  title: string;
  message: string;
  show: boolean;
  valid: boolean;
};

export const industryOptions = [
  'Agriculture',
  'Aerospace',
  'Construction',
  'Education',
  'Entertainment',
  'Finance',
  'Food Processing',
  'Healthcare',
  'Heavy industry',
  'Hospitality',
  'Manufacturing',
  'Mining',
  'News Media',
  'Pharmaceutical',
  'Software',
  'Technology',
  'Telecommunication',
  'Transportation',
  'Other',
] as const;

export enum ReasonsForIncoporatingInSingapore {
  'I_RESIDE_IN_SINGAPORE' = 'I reside in Singapore',
  'EXPANSION_OF_EXISTING_BUSINESS' = 'Expansion of existing business',
  'ENTERING_INTO_ASIA' = 'Entering into Asia',
  'REQUESTED_BY_PARTIES_WE_WORK_WITH' = 'Requested by parties we work with',
  'SINGAPORE_IS_AN_INTERNATIONALLY_RECOGNIZED_HUB' = 'Singapore is an internationally recognized hub',
}

export enum FundSourcesEnum {
  'SAVINGS_FROM_EMPLOYMENT' = 'Savings from employment',
  'PROFITS_GENERATED_FROM_BUSINESS' = 'Profits generated from business',
  'INVESTMENT_GAIN' = 'Investment gain',
  'LOANS_FROM_BANKS_OR_FINANCIAL_INSTITUTIONS' = 'Loans (e.g., Banks or Financial Institutions)',
  'LOANS_FROM_FAMILY_AND_FRIENDS' = 'Loans from family and friends',
  'PERSONAL_SAVINGS' = 'Personal Savings',
  'INHERITANCE' = 'Inheritance',
  'INVESTORS' = 'Investors',
}

export enum NextStepsForCompany {
  'CREATE_A_HOLDING_AND_HOLD_ASSETS_OR_SHARES' = 'Create a holding and hold assets/shares',
  'EMPLOY_MYSELF_APPLYING_FOR_A_WORKPASS_EP_ENTREPASS_IF_NECESSARY' = 'Employ myself (applying for a workpass/EP/Entrepass if necessary)',
  'MOVE_TO_SINGAPORE' = 'Move to Singapore',
  'RAISE_FUNDS_QUICKLY_FROM_VCS_OR_ANGELS' = 'Raise funds quickly from VCs or Angels',
  'START_MY_OWN_BUSINESS_GROW_STEADILY_AND_PROFITABLY' = 'Start my own business, grow steadily and profitably',
  'STARTUP_PROJECT_WE_WANT_TO_GROW_FAST' = 'Startup project, we want to grow fast',
  // 'OTHERS_PLEASE_SPECIFY' = 'Others, please specify',
}

export enum CryptoCurrencyActivityEnum {
  Trading = 'Trading',
  Mining = 'Mining',
  Others = 'Others',
}

enum FunctionalRoleEnum {
  Accounting = 'Accounting',
  Compliance = 'Compliance',
  Finance = 'Finance',
  HumanResources = 'Human Resources',
  Legal = 'Legal',
  Operations = 'Operations',
  Other = 'Other',
}

export enum BoardPositionEnum {
  President = 'President',
  Secretary = 'Secretary',
  Treasurer = 'Treasurer',
  Manager = 'Manager',
  BankSignatory = 'BankSignatory',
  // Temporarily removed because these aren't board positions, they're board-appointed people.
  // CEO = 'CEO',
  // CFO = 'CFO',
}

export enum EducationalQualificationEnum {
  PrimaryEducation = 'PrimaryEducation',
  SecondaryEducation = 'SecondaryEducation',
  VocationalEducation = 'VocationalEducation',
  BachelorsDegree = `BachelorsDegree`,
  MastersDegree = `MastersDegree`,
  DoctrateOrHigher = 'DoctrateOrHigher',
  Professional = 'Professional',
  Diploma = 'Diploma',
}

export enum JobTitleEnum {
  ChiefExecutiveOfficer = 'Chief Executive Officer',
  ChiefTechnologyOfficer = 'Chief Technology Officer',
  ChiefFinancialOfficer = 'Chief Financial Officer',
  ChiefOperatingOfficer = 'Chief Operating Officer',
  ChiefMarketingOfficer = 'Chief Marketing Officer',
  ChiefInformationOfficer = 'Chief Information Officer',
  DirectorOfComplaince = 'Director of Compliance',
  DirectorOfOperations = 'Director of Operations',
  HeadOfTax = 'Head of Tax',
  Others = 'Other',
}

export enum TaxClassificationEntityTypeEnum {
  C_CORPORATION = 'C_CORPORATION',
  S_CORPORATION = 'S_CORPORATION',
  PARTNERSHIP = 'PARTNERSHIP',
  INDIVIDUAL_OR_SOLE_PROPRIETORSHIP = 'INDIVIDUAL_OR_SOLE_PROPRIETORSHIP',
  DISREGARDED_ENTITY = 'DISREGARDED_ENTITY',
  FOREIGN_CORPORATION = 'FOREIGN_CORPORATION',
  FOREIGN_PARTNERSHIP = 'FOREIGN_PARTNERSHIP',
}

export enum NonUSEntityTaxClassificationEntityTypeEnum {
  FOREIGN_CORPORATION = 'FOREIGN_CORPORATION',
  FOREIGN_PARTNERSHIP = 'FOREIGN_PARTNERSHIP',
}

const JobTitleOptionsForIncorpForm = [
  JobTitleEnum.ChiefExecutiveOfficer,
  JobTitleEnum.ChiefTechnologyOfficer,
  JobTitleEnum.ChiefFinancialOfficer,
  JobTitleEnum.ChiefOperatingOfficer,
  JobTitleEnum.ChiefMarketingOfficer,
  JobTitleEnum.ChiefInformationOfficer,
  JobTitleEnum.Others,
];

const BoardTitleOptionsForIncorpForm = [
  BoardPositionEnum.President,
  BoardPositionEnum.Secretary,
  BoardPositionEnum.Treasurer,
];

export type CorporationHasDirectorAdditionalInformation = {
  isDirector?: boolean;
  isAuthorizedSignatory?: boolean;
  isManager?: boolean;
  jobTitle?: string[];
  boardPosition?: BoardPositionEnum[];
  sharePercentage?: number;
  startDateOfEmployment?: string;
  shareCount?: number;
  hasSignificantControl?: boolean;
  memberControlType?: string;
  isEEAResident?: boolean;
  isDigitallyAuthorisedToFileOnline?: boolean;
  isResponsibleParty?: boolean;
};

export type TCorporationHasDirectorIncorporationInfo = {
  identityProofTypeUsedByDirector?: LegacyDocumentType;
  hasUsedDifferentName?: boolean;
  jobTitle?: string;
};

interface ContactListType {
  name?: string;
  email?: string;
  phoneNumber?: string;
}

enum RootFiAccountingSoftwareType {
  ZOHO_BOOKS = 'ZOHO_BOOKS',
  QUICKBOOKS_SANDBOX = 'QUICKBOOKS_SANDBOX',
  QUICKBOOKS = 'QUICKBOOKS',
  XERO = 'XERO',
  TALLY = 'TALLY',
  SAGE_CLOUD_ACCOUNTING = 'SAGE_CLOUD_ACCOUNTING',
  MS_DYNAMICS_365 = 'MS_DYNAMICS_365',
  SAGE_ZA_CLOUD_ACCOUNTING = 'SAGE_ZA_CLOUD_ACCOUNTING',
  MYOB_BUSINESS = 'MYOB_BUSINESS',
  WAVE = 'WAVE',
  ODOO_ACCOUNTING = 'ODOO_ACCOUNTING',
  NETSUITE = 'NETSUITE',
  WAFEQ = 'WAFEQ',
  MEKARI_JURNAL = 'MEKARI_JURNAL',
  BUSY = 'BUSY',
  ROOTFI_SANDBOX = 'ROOTFI_SANDBOX',
  QOYOD = 'QOYOD',
}

// Source for values: https://docs.merge.dev/guides/merge-link/single-integration/
// Add others as needed.
enum MergePayrollSoftwareType {
  BAMBOO_HR = 'bamboohr',
  GUSTO = 'gusto',
  JUSTWORKS = 'justworks',
  ZOHO_PEOPLE = 'zoho-people',
}

export type CorporationMails = {
  isFileSeen?: boolean;
  mailTitle?: string;
};

enum AWSEntityOnboardingStages {
  COMPANY_DETAILS = 'COMPANY_DETAILS',
  KEY_PERSON_DETAILS = 'KEY_PERSON_DETAILS',
  ADDRESS_INFORMATION = 'ADDRESS_INFORMATION',
  DOCUMENTS = 'DOCUMENTS',
}

export type AdditionalInformationForCorporation = {
  // if they have paid for compliance
  isPayingForCompliance?: boolean;
  isDueForSinglePaidComplianceCall?: boolean;

  // US Direct Tax Questions - Start
  jurisdictionRegistrations?: string[];
  hasMoreThan500DollarsInFederalTaxes?: MCQTypes;
  hasElectedSCorporationTaxStatus?: boolean;
  isSingleOwnerLLC?: boolean;
  isForeignOwned?: boolean;
  hasForeignSubsidiaries?: boolean;
  hasForeignBankAccountsOver10k?: boolean;
  // US Direct Tax Questions - End

  // US HR & Payroll Tax Questions - Start
  hasFullTimeUSEmployees?: boolean;
  providesEmployeeBenefitsToFullTimeUSEmployees?: boolean;
  hasContractorPaymentsOver600?: boolean;
  hasForeignPayments?: boolean;
  hasEmployeeStockPurchaseProgram?: boolean;
  hasDiscountedStockPurchasePlan?: boolean;
  hasQuarterlyWagesOver1500?: boolean;
  has20WeeksWithEmployees?: boolean;
  withholdsEmployeeTaxesOrSSOrMedicare?: boolean;
  hasIRSForm944Notification?: boolean;
  submitsIRSInformationReturnsByMail?: boolean;
  isApplicableLargeEmployer?: boolean;
  // US HR & Payroll Tax Questions - End

  currentStageOfCorporationInOnboardingProcess?: CorporationOnboardingStages;
  stagesOfCorporationOnboardingProcessesFinished?: CorporationOnboardingStages[];

  isSalesTaxOnboardingComplete?: boolean;

  stateOfIncorporation?: string;

  registeredAgentName?: string;
  registeredAgentAddress?: IAddress;

  residentDirectorName?: string;
  residentDirectorAddress?: IAddress;

  corporationDescription?: string;

  authorizedSignatoryName?: string;
  authorizedSignatoryAddress?: IAddress;
  authorizedSignatoryNumber?: string;
  authorizedSignatoryPosition?: string;
  authorizedSignatoryEmail?: string;
  authorizedSignatoryStartDate?: string;
  authorizedSignatoryOwnershipPercentage?: number;
  authorizedSignatoryDateOfBirth?: string;
  authorizedSignatoryNationalities?: Country[];
  authorizedSignatorySSNSecretId?: string;
  authorizedSignatoryHasSSN?: boolean;

  operationalStates?: string[];
  operationalCountries?: Country[];

  contactList?: ContactListType[];

  employeeCount?: number;

  isSubjectToRegulations?: boolean;
  reasonForRegulation?: string;

  optForRegisteredAgent?: MCQTypes;

  optForResidentDirector?: MCQTypes;

  // Does the company have employees or contractors in their service zone?
  haveEmployeesOrContractors?: boolean;

  hasSamePhysicalAndMailingAddress?: boolean; // backend doesn't accept this, it's only for frontend states

  industry?: (typeof industryOptions)[number];

  marketPlace?: Marketplace[];

  naicsCode?: number; // https://www.naics.com/search/

  lastBusinessLicenseRenewalDate?: string; // ISO 8601 date string.

  // VAT period info for UAE Corporations:
  firstVATPeriodStartMonth?: number; // 1-indexed month
  VATEvaluationPeriod?: 'MONTHLY' | 'QUARTERLY';

  // These 2 questions were added for FinCen FBAR
  fbarQualification?: {
    hasInterestInNonUSSubsidiaries?: MCQTypes;
    hasMoreThanTenThousandInPreviousFiscalYear?: MCQTypes;
  };

  companyLegalName2?: string;

  proposedEntityNameFullform?: string;

  selectedAccountingSoftware?: RootFiAccountingSoftwareType | 'OTHER';
  // Only populated if the above field is 'OTHER':
  selectedOtherAccountingSoftware?: string;

  selectedPayrollSoftware?: MergePayrollSoftwareType | 'OTHER';
  // Only populated if the above field is 'OTHER':
  selectedOtherPayrollSoftware?: string;

  accountingBasis?: AccountingBasis;
  accountingFrequency?: AccountingFrequency;
  taxedAs?: TaxClassificationEntityTypeEnum;

  // This is an interim solution to track sales tax enablement on the corporation level.
  // In the long run, we should do this by checking whether an entitlement exists for each corporation.
  // Until that system works, on Maple Billing, etc, we will just throw a boolean in here.
  salesTaxEnabled?: boolean;

  // Adding this toggle as a feature flag for the users who wants to get bookkeeping
  // In future, we might not need it
  bookkeepingEnabled?: boolean;

  requestedNewSalesTaxRegistrations?: USStatesAndTerritories[];

  // Used In C Corp Form
  structure?: string;

  companyService?: BusinessPurposeEnum;

  awsEntityOnboardingInformation?: {
    status: IncorporationRequestStatus;
    currentStageOfCorporationInOnboardingProcess: AWSEntityOnboardingStages;
    stagesOfCorporationOnboardingProcessesFinished: AWSEntityOnboardingStages[];
    yearAtWhichTRCToBeObtained?: number;
  };

  businessPurpose?: BusinessPurposeEnum;

  naceCode?: string;
  natureOfBusiness?: string;
  registrationNumber?: string;

  registeredAgentDocumentAccess?: boolean;
  virtualAddressDocumentAccess?: boolean;

  phoneNumber?: string;

  // tax and accounting information
  // taxAndAccountingOnboardingInformation?: {
  //   currentStage?: TaxAndAccountingOnboardingStages;
  //   stagesOfCorporationOnboardingProcessesFinished?: TaxAndAccountingOnboardingStages[];
  // };
};

const ComplianceCalendarStatus = {
  NotStarted: 'Not Started',
  Upcoming: 'Upcoming',
  StartNow: 'Start Now',
  Continue: 'Continue',
  InProgress: 'In Progress',
  DeadlineApproaching: 'Deadline Approaching',
  Completed: 'Completed',
  Overdue: 'Overdue',
} as const;

enum MarketPlace {
  Shopify = 'Shopify',
  Amazon = 'Amazon',
  Walmart = 'Walmart',
  eBay = 'eBay',
  Etsy = 'Etsy',
  Quickbooks = 'Quickbooks',
  NetSuite = 'NetSuite',
  Sellercloud = 'Sellercloud',
  Stripe = 'Stripe',
  Other = 'Other',
  None = 'None',
}

export enum StructureTypes {
  PARENT_COMPANY = 'PARENT_COMPANY',
  SUBSIDIARY = 'SUBSIDIARY',
  STANDALONE = 'STANDALONE',
  NOT_SURE = 'NOT_SURE',
}

export enum BusinessPurposeEnum {
  ACCOMMODATIONS = 'ACCOMMODATIONS',
  CONSTRUCTION = 'CONSTRUCTION',
  FINANCE = 'FINANCE',
  FOOD_SERVICE = 'FOOD_SERVICE',
  HEALTH_CARE = 'HEALTH_CARE',
  INSURANCE = 'INSURANCE',
  REAL_ESTATE = 'REAL_ESTATE',
  RENTAL_LEASING = 'RENTAL_LEASING',
  RETAIL = 'RETAIL',
  SOCIAL_ASSISTANCE = 'SOCIAL_ASSISTANCE',
  TRANSPORTATION = 'TRANSPORTATION',
  WAREHOUSING = 'WAREHOUSING',
  WHOLESALE = 'WHOLESALE',
  CONSULTING = 'CONSULTING',
  MANUFACTURING = 'MANUFACTURING',
  ORGANIZATION = 'ORGANIZATION',
  RENTAL = 'RENTAL',
  REPAIR = 'REPAIR',
  SELL_GOODS = 'SELL_GOODS',
  SERVICE = 'SERVICE',
  SOFTWARE_SERVICES = 'SOFTWARE_SERVICES',
  OTHER = 'OTHER',
}

// DocumentFolderType indicates the id for a specific document folder/file type
// It is not concrete yet but we need to finalise these types in future.
enum DocumentFolderTypesEnum {
  BANK_STATEMENTS_FOLDER = 'Bank Statements',
  BANK_STATEMENTS_QUARTER_FOLDER = 'Bank statements',
  BANK_STATEMENTS_FILE = 'bankStatements',
  INVOICES = 'Invoices',
  SALES_TRANSACTION = 'salesTransaction',
  GENERAL_DOCUMENTS = 'generalDocuments',
  FINANCIAL_DOCUMENTS = 'financialDocuments',
  MIS_REPORTS = 'misReports',
}

export const DocumentFolderTypes = {
  bankStatementsFolder: DocumentFolderTypesEnum.BANK_STATEMENTS_FOLDER,
  bankstatementsFolder: DocumentFolderTypesEnum.BANK_STATEMENTS_QUARTER_FOLDER,
  bankStatementsFile: DocumentFolderTypesEnum.BANK_STATEMENTS_FILE,
  financialDocuments: DocumentFolderTypesEnum.FINANCIAL_DOCUMENTS,
  misReports: {
    name: DocumentFolderTypesEnum.MIS_REPORTS,
    Q1: `Q1`,
    Q2: `Q2`,
    Q3: `Q3`,
    Q4: `Q4`,
  },
} as const;

export const MISReportCardInfo = {
  Q1: { cardTitle: 'MIS Report for Q1', modalTitle: 'Q1 Reports' },
  Q2: { cardTitle: 'MIS Report for Q2', modalTitle: 'Q2 Reports' },
  Q3: { cardTitle: 'MIS Report for Q3', modalTitle: 'Q3 Reports' },
  Q4: { cardTitle: 'MIS Report for Q4', modalTitle: 'Q4 Reports' },
  cardDescription: 'View your previous MIS report here',
} as const;

export enum DriveViewType {
  BOOKKEEPING = 'bookkeeping',
}

export type TCurrencyInfo = {
  name: string;
  style: string;
  locale: string;
  currency: Currency;
};
